import axios from '../axios'

/* 
 * 轮播图管理模块
 */
//查询
export const getList = (params) => {
  return axios({
      url: '/home/banner/list',
      method: 'get',
      params
  })
}
// 新增
export const addApi = data => {
    return axios({
        url: '/home/banner',
        method: 'post',
        data
    })
}
//更新
export const updateApi = data => {
  return axios({
      url: '/home/banner',
      method: 'put',
      data
  })
}
//查详情
export const detailApi= (id) => {
  return axios({
      url: `/home/banner/${id}`,
      method: 'get',
      // params
  })
}
//删除
export const deleteApi= (id) => {
  return axios({
      url: `/home/banner/${id}`,
      method: 'delete',
      // params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/bananer.js